export const asDate = (iso: string) => {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) throw new Error("Invalid ISO date");
  return d;
};
export const iso = (d: Date) => d.toISOString();
export const isoOrNull = (d?: Date | null): string | null =>
  d ? d.toISOString() : null;
